/** Cohort retention triangle (D529): each row is a cohort, each column a period since the cohort started. */
import { buildHeatGrid } from './heatmap.js';
import { isFiniteNumber } from './numbers.js';
/** Retention rates per cohort and period, heat levels over 0 … 1, and the weighted average row. */
export function cohortTriangle(inputs, options = {}) {
    const periods = options.periods ?? inputs.reduce((m, r) => Math.max(m, r.retained.length), 0);
    const heatInputs = inputs.flatMap((r, row) => Array.from({ length: periods }, (_, col) => {
        const v = r.retained[col];
        return { row, col, value: isFiniteNumber(v) && r.size > 0 ? v / r.size : null };
    }));
    const grid = buildHeatGrid({ rows: inputs.length, cols: periods, cells: heatInputs, domain: [0, 1], ...(options.steps !== undefined ? { steps: options.steps } : {}) });
    const rows = inputs.map((r, row) => ({
        cohort: r.cohort,
        size: r.size,
        cells: Array.from({ length: periods }, (_, period) => {
            const raw = r.retained[period];
            const retained = isFiniteNumber(raw) ? raw : null;
            const heat = grid.cells[row * periods + period];
            return { period, retained, rate: heat?.value ?? null, level: heat?.level ?? null, pending: retained === null };
        }),
    }));
    const average = Array.from({ length: periods }, (_, period) => {
        let kept = 0;
        let base = 0;
        for (const r of inputs) {
            const v = r.retained[period];
            if (isFiniteNumber(v) && r.size > 0) {
                kept += v;
                base += r.size;
            }
        }
        return base === 0 ? null : kept / base;
    });
    return { rows, periods, average, grid };
}
//# sourceMappingURL=cohort.js.map